ShopifyQO = {}
ShopifyQO.itemsToAdd = [];
ShopifyQO.addItemstoTheCart = function() {
console.log(ShopifyQO.itemsToAdd)
if (ShopifyQO.itemsToAdd.length) {
    var item = ShopifyQO.itemsToAdd.pop();
    $.ajax({
    url: '/cart/add',
    dataType: 'json',
    type: 'post',
    data: item,
    success: ShopifyQO.addItemstoTheCart,
    error: ShopifyQO.addItemstoTheCart
    });
} else {
    $(".quantity").val("0")
    //alert("Added to cart")
    window.location.href = '/cart';
}
};
jQuery(function($) {
$('.quick-products .quantity:first').focus();
$('[max]').change(function() {
    var max = parseInt($(this).attr('max'), 10);
    var value = parseInt($(this).val(), 10) || 0;
    if (value > max) { 
    alert('We only have ' + max + ' of this item in stock');
    $(this).val(max); 
    }    
});


$('.add-variant-to-cart').click(function(ev) {
    var variant_id = $(this).attr('data-variant-id')
    //console.log("variant_id", variant_id, ".quantity[data-id='" + variant_id + "']")
    var quantity = $(".quantity[data-id='" + variant_id + "']").val()
    //console.log("quantity", quantity)
    

    $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    type: 'post',
    data: {
        id: variant_id,
        quantity: quantity
    },
    success: function() {
        alert(quantity + " items added to cart")
    }

    });  

});

    $('.add-to-cart-order-form').click(function(ev) {
    ev.preventDefault() 
    $('.add-to-cart-order-form').addClass('disabled').attr('disabled','disabled');
    // Resetting.
    ShopifyQO.itemsToAdd = [];
    $('.quantity').each(function() {
    var quantity = parseInt($(this).val(), 10);
    if (quantity && $(this).attr('data-id')) {
        ShopifyQO.itemsToAdd.push( { id: $(this).attr('data-id'), quantity: quantity } );
    }
    });     
    if (ShopifyQO.itemsToAdd.length) {
    ShopifyQO.addItemstoTheCart();
    }
    else {
    alert('All quantities are set to zero.');
    $('.add-to-cart-order-form').removeAttr('disabled').removeClass('disabled');
    }
});

jQuery('body').on('click', '.show-variants', function(ev) {
    ev.preventDefault() 
    var product_id = $(this).data("product-id")
    $(".variants-product-id" + product_id).removeClass("p-hidden")
    $(this).removeClass("show-variants").addClass("hide-variants").html("Hide variants")
})
jQuery('body').on('click', '.hide-variants', function(ev) {
    ev.preventDefault() 
    var product_id = $(this).data("product-id")
    $(".variants-product-id" + product_id).addClass("p-hidden")
    $(this).removeClass("hide-variants").addClass("show-variants").html("Show variants")
})

});